import React from 'react';
import { UrgencyBar } from '../components/landing/UrgencyBar';
import { Hero } from '../components/landing/Hero';
import { Hook } from '../components/landing/Hook';
import { PainAgitation } from '../components/landing/PainAgitation';
import { Revelation } from '../components/landing/Revelation';
import { Testimonials } from '../components/landing/Testimonials';
import { Offer } from '../components/landing/Offer';
import { Pricing } from '../components/landing/Pricing';
import { FAQ } from '../components/landing/FAQ';
import { Guarantee } from '../components/landing/Guarantee';
import { Closing } from '../components/landing/Closing';
import { Footer } from '../components/landing/Footer';
export function Landing() {
  return <div className="min-h-screen flex flex-col font-body" data-id="element-198">
      <UrgencyBar data-id="element-199" />
      <main className="flex-grow" data-id="element-200">
        <Hero data-id="element-201" />
        <Hook data-id="element-202" />
        <PainAgitation data-id="element-203" />
        <Revelation data-id="element-204" />
        <Testimonials data-id="element-205" />
        <Offer data-id="element-206" />
        <Pricing data-id="element-207" />
        <FAQ data-id="element-208" />
        <Guarantee data-id="element-209" />
        <Closing data-id="element-210" />
      </main>
      <Footer data-id="element-211" />
    </div>;
}